angular.module('zc')
  .component('zcSessionSampler', {
    templateUrl: '/templates/projects/components/session_sampler/session_sampler.html',
    bindings: {
      project: '<',
      title: '@',
      indicator: '@',
    },
    controller: zcSessionSampler,
  });

zcSessionSampler.$inject = ['$filter', '$scope', 'MongoSession', 'MongoHistory'];
function zcSessionSampler($filter, $scope, MongoSession, MongoHistory) {
  const vm = this;

  vm.from = moment().subtract(1, 'day').toDate();
  vm.to = moment().subtract(1, 'hour').toDate();
  vm.totalCount = 0;
  vm.matchedCount = 0;
  vm.matchedPercentage = 0;
  vm.devices = [
    { name: $filter('translate')('projects.components.sessionSampler.allDevice'), value: 'all' },
    { name: $filter('translate')('projects.components.sessionSampler.pc'), value: 'pc' },
    { name: $filter('translate')('projects.components.sessionSampler.sp'), value: 'sp' },
  ];
  if(vm.project.enable_app) {
    vm.devices.push({ name: $filter('translate')('projects.components.sessionSampler.app'), value: 'app' });
  }
  vm.device = vm.devices[0];
  vm.$onInit = () => {
    $scope.$watch('$ctrl.device.value', onChangeDevice);
  };

  function onChangeDevice(device) {
    if(vm.indicator === 'page_types_cover_rate') {
      findHistories(device);
    } else {
      findSessions(device);
    }
  }

  function findSessions(device) {
    const query = buildQuery(device);
    MongoSession.find(query)
      .then(sessions => {
        vm.totalCount = sessions.length;
        vm.matchedCount = filterSessions(sessions).length;
        vm.matchedPercentage = calculateMatchedPercentage(vm.totalCount, vm.matchedCount);
      });
  }

  function findHistories(device) {
    const query = buildQuery(device);
    MongoHistory.find(query)
      .then(histories => {
        vm.totalCount = histories.length;
        vm.matchedCount = _.filter(histories, history => history.page_types.length).length;
        vm.matchedPercentage = calculateMatchedPercentage(vm.totalCount, vm.matchedCount);
      });
  }

  function buildQuery(device) {
    const query = {
      apikey: vm.project.apikey,
      opened_at: { $gte: vm.from, $lt: vm.to },
      is_exclude: false,
    };
    if(device === 'pc') {
      query.device = { $in: ['pc', 'tablet'] };
    } else if(device === 'sp') {
      query.device = 'sp';
    } else if(device === 'app') {
      query.device = 'app';
    }
    return query;
  }

  function filterSessions(sessions) {
    let filter;
    switch (vm.indicator) {
      case 'google_analytics_cover_rate':
        filter = session => _.get(session, 'google_analytics.first_visit_at');
        break;
      case 'cart_button_click_rate':
        filter = session => _.get(session, 'cart_button_click_count') >= 1;
        break;
      case 'login_rate':
        filter = session => _.get(session, 'is_login');
        break;
      case 'item_price_found_rate':
        filter = session => _.get(session, 'total_item_price') >= 1;
        break;
      case 'item_list_price_found_rate':
        filter = session => _.get(session, 'average_recent5_first_item_list_price') >= 1;
        break;
      case 'cart_price_found_rate':
        filter = session => _.get(session, 'cart_price') >= 1;
        break;
      default:
        throw new Error(`Unknown indicator! ${vm.indicator}`);
    }
    return _.filter(sessions, filter);
  }

  function calculateMatchedPercentage(totalCount, matchedCount) {
    return totalCount ? matchedCount / totalCount * 100 : 0;
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/components/session_sampler/session_sampler.js